
import {of as observableOf,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';
import { IIWebhooksForList, IWebhook, IWebhookUpdate } from './webhooks-model';

@Injectable()
export class WebhooksService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}${WebhooksService.ENDPOINT}`; }
    private static readonly ENDPOINT = 'webhooks';

    public getWebhooks(): Observable<SuccessResponse<IIWebhooksForList> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IIWebhooksForList>>(WebhooksService.URL).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public addWebhook(webhook: IWebhook): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(WebhooksService.URL, webhook).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public updateWebhook(webhook: IWebhookUpdate): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(WebhooksService.URL, webhook).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public connectOAuth(webhook: IWebhookUpdate): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(WebhooksService.URL + '/oauth-connect', webhook).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public deleteWebhooks(names: string[]): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .delete<SuccessResponse<boolean>>(WebhooksService.URL + '?names=' + names).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

}
